/**
 * SolidlyAI Agents mark — the Solidly diamond-node cluster.
 * Renders in `currentColor`, so set the color via CSS on the parent.
 */
const Logo = ({ size = 26, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    className={className}
    role="img"
    aria-label="SolidlyAI Agents"
    fill="none"
  >
    {/* Outline diamond connecting the four node centers */}
    <polygon
      points="50,20 80,50 50,80 20,50"
      fill="none"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinejoin="round"
    />
    {/* Four node diamonds (N, E, S, W) */}
    <polygon points="50,8 62,20 50,32 38,20" fill="currentColor" />
    <polygon points="80,38 92,50 80,62 68,50" fill="currentColor" />
    <polygon points="50,68 62,80 50,92 38,80" fill="currentColor" />
    <polygon points="20,38 32,50 20,62 8,50" fill="currentColor" />
    {/* Center node */}
    <circle cx="50" cy="50" r="13" fill="currentColor" />
  </svg>
);

export default Logo;
